import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouterLegacy } from 'core/routerUtils';
import * as irregularitiesActions from 'features/irregularities/duck';
import * as taskActions from 'features/task-management/duck';
import { useTranslation, withTranslation } from 'react-i18next';
import { AlertMessage, Spinner, AlertNotice, SimpleModal } from 'shared/components/index';
import { isEmpty, orderBy } from 'lodash';
import { SelectRosterExaminee } from 'features/irregularities/index';
import AvailableIcon from 'assets/svgs/assessmentAvailableIcon.svg';
import CompletedIcon from 'assets/svgs/assessmentCompletedIcon.svg';
import TerminatedIcon from 'assets/svgs/assessmentTerminatedIcon.svg';
import { ASSESSMENT_STATUS, ASSESSMENT_LABELS } from 'shared/constants';
import './MarkTestComplete.scss';

const orderRegsBy = 'firstName';

class MarkTestComplete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedExaminee: null,
      completeModalOpen: false,
      showAlertMessage: false,
      alertMessage: '',
      alertIsError: false,
    };

    this.onSelectExaminee = this.onSelectExaminee.bind(this);
    this.onCompleteAssessment = this.onCompleteAssessment.bind(this);
    this.closeCompleteModal = this.closeCompleteModal.bind(this);
    this.removeAlertMessage = this.removeAlertMessage.bind(this);

    this.props.actions.getRoomRegs(props.match.params.roomId, orderRegsBy);
    this.props.actions.getTcEventRegs(props.match.params.eventId, orderRegsBy);
  }

  componentWillUnmount() {
    this.props.actions.getRegsAssessmentsAction({ data: {}, error: null });
  }

  onSelectExaminee(selected) {
    this.setState({
      selectedExaminee: selected,
    });

    if (selected) {
      this.props.actions
        .getRegsAssessments(selected.value.regId, this.props.match.params.eventId)
        .then(() => {});
    } else {
      this.props.actions.getRegsAssessmentsAction({});
    }
  }

  closeCompleteModal() {
    this.setState({
      completeModalOpen: false,
    });
  }

  removeAlertMessage() {
    this.setState({
      showAlertMessage: false,
    });
  }
  onCompleteAssessment(complete, assessment) {
    const { selectedExaminee } = this.state;
    const { regsAssessments, match } = this.props;

    if (complete) {
      const updateObject = {
        admin_id: regsAssessments.admin_id,
        test_launch_id: this.state.currentAssessment.test_launch_id,
        status: this.state.currentAssessment.status_fl,
        label: this.state.currentAssessment.label,
        test_center_event_id: +match.params.eventId,
      };
      this.props.actions
        .updateRegAssessment(selectedExaminee.value.regId, updateObject)
        .then(() => {
          this.props.actions.getRegsAssessments(selectedExaminee.value.regId, match.params.eventId);
          this.closeCompleteModal();

          if (this.props.errorUpdateAssessment) {
            this.setState({
              showAlertMessage: true,
              alertMessage: this.props.t('errors.somethingWentWrong'),
              alertIsError: true,
              currentAssessment: {},
            });
          } else {
            this.setState({
              showAlertMessage: true,
              alertMessage: this.props.t('markTestCompleteDashboard.successMessage'),
              alertIsError: false,
              currentAssessment: {},
            });
          }
        });
    } else {
      this.removeAlertMessage();
      this.setState({
        completeModalOpen: true,
        currentAssessment: assessment,
      });
    }
  }

  render() {
    const {
      roomRegsOptions,
      eventRegsOptions,
      roomRegsOptionsLoading,
      eventRegsOptionsLoading,
      regsAssessments,
      loadingRegsAssessments,
      errorRegsAssessments,
    } = this.props;

    const { selectedExaminee, completeModalOpen, showAlertMessage, alertMessage, alertIsError } =
      this.state;
    let alertNoticeMessage;

    if (selectedExaminee) {
      alertNoticeMessage =
        errorRegsAssessments && this.props.t('markTestCompleteDashboard.errorReg');
    } else {
      alertNoticeMessage = this.props.t('markTestCompleteDashboard.modulesInfoMessage');
    }

    if (roomRegsOptionsLoading || eventRegsOptionsLoading) {
      return <Spinner />;
    }

    return (
      <div className="mark-test-complete-container col col-md-11 col-lg-9">
        <h4 className="page-title mt-3">{this.props.t('markTestCompleteDashboard.title')}</h4>
        <p>{this.props.t('markTestCompleteDashboard.pageMessage')}</p>
        <div className="border-box-silver">
          <SelectRosterExaminee
            selectedExaminee={selectedExaminee}
            onSelectExaminee={this.onSelectExaminee}
            roomRegsOptions={roomRegsOptions}
            eventRegsOptions={eventRegsOptions}
            selectLabel="markTestCompleteDashboard.selectLabel"
            selectPlaceholder="markTestCompleteDashboard.selectPlaceholder"
            matchIdMessage="markTestCompleteDashboard.matchIdMessage"
            roomSelectedFlag
          />
          <div className="assessment-cards-container">
            {loadingRegsAssessments ? (
              <Spinner />
            ) : selectedExaminee &&
              !isEmpty(regsAssessments) &&
              regsAssessments.assessments.length ? (
              orderBy(regsAssessments.assessments, 'display_order_id').map((assessment, idx) => (
                <AssessmentCard
                  key={`assement-${idx}`}
                  assessment={assessment}
                  onCompleteAssessment={this.onCompleteAssessment}
                />
              ))
            ) : (
              <AlertNotice
                message={alertNoticeMessage}
                type={errorRegsAssessments ? 'error' : 'info'}
              />
            )}
          </div>
        </div>
        <div className="sticky-button mt-1">
          <button className="btn btn-outline ml-0 mt-3" onClick={this.props.history.goBack}>
            {this.props.t('common.labels.back')}
          </button>
        </div>
        <AlertMessage
          show={showAlertMessage}
          message={alertMessage}
          removeMessage={this.removeAlertMessage}
          isError={alertIsError}
        />
        <SimpleModal
          isOpen={completeModalOpen}
          onCancel={this.closeCompleteModal}
          onConfirm={() => this.onCompleteAssessment(true)}
          confirmLabel={this.props.t('common.labels.continue')}
          cancelLabel={this.props.t('common.labels.cancel')}
          headline={this.props.t('markTestCompleteDashboard.modalComplete.header')}
          message={this.props.t('markTestCompleteDashboard.modalComplete.message')}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    eventRegsOptions: state.irregularities.tcEventRegs,
    roomRegsOptions: state.irregularities.roomRegs,
    regsAssessments: state.taskManagement.regsAssessments,
    loadingRegsAssessments: state.taskManagement.loadingRegsAssessments,
    errorUpdateAssessment: state.taskManagement.errorUpdateAssessment,
    errorRegsAssessments: state.taskManagement.errorRegsAssessments,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...irregularitiesActions,
        ...taskActions,
      },
      dispatch
    ),
  };
}

export default withTranslation()(
  withRouterLegacy(connect(mapStateToProps, mapDispatchToProps)(MarkTestComplete))
);

MarkTestComplete.propTypes = {
  t: PropTypes.func.isRequired,
  // Props from react-router (via withRouterLegacy)
  match: PropTypes.shape({
    params: PropTypes.shape({
      roomId: PropTypes.string.isRequired,
      eventId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,

  // Props from mapStateToProps
  eventRegsOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  roomRegsOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  regsAssessments: PropTypes.shape({
    admin_id: PropTypes.number,
    assessments: PropTypes.arrayOf(
      PropTypes.shape({
        test_launch_id: PropTypes.number,
        status_fl: PropTypes.string,
        label: PropTypes.string,
        display_order_id: PropTypes.number,
      })
    ),
  }).isRequired,
  loadingRegsAssessments: PropTypes.bool.isRequired,
  roomRegsOptionsLoading: PropTypes.bool,
  eventRegsOptionsLoading: PropTypes.bool,
  errorUpdateAssessment: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  errorRegsAssessments: PropTypes.oneOfType([PropTypes.bool, PropTypes.object, PropTypes.string]),

  // Props from mapDispatchToProps
  actions: PropTypes.shape({
    getRoomRegs: PropTypes.func.isRequired,
    getTcEventRegs: PropTypes.func.isRequired,
    getRegsAssessmentsAction: PropTypes.func.isRequired,
    getRegsAssessments: PropTypes.func.isRequired,
    updateRegAssessment: PropTypes.func.isRequired,
  }).isRequired,
};

const AssessmentCard = ({ assessment, onCompleteAssessment }) => {
  const { t } = useTranslation();
  return (
    <div
      className={`card-content ${
        assessment.status_fl === ASSESSMENT_STATUS.unavailable ? 'disabled' : ''
      }`}>
      <div className="icon-container ">
        {(assessment.status_fl === ASSESSMENT_STATUS.available ||
          assessment.status_fl === ASSESSMENT_STATUS.launched) && <AvailableIcon />}
        {assessment.status_fl === ASSESSMENT_STATUS.completed && <CompletedIcon />}
        {assessment.status_fl === ASSESSMENT_STATUS.terminated && <TerminatedIcon />}
      </div>
      <div className="ps-3">
        <p className={`status-label mb-1 ${ASSESSMENT_LABELS[assessment.status_fl]}`}>
          {ASSESSMENT_LABELS[assessment.status_fl]}
        </p>
        <p className="fw-bold mb-0">{assessment.label}</p>
      </div>
      {(assessment.status_fl === ASSESSMENT_STATUS.available ||
        assessment.status_fl === ASSESSMENT_STATUS.launched) && (
        <div className="complete-btn">
          <button
            onClick={() => onCompleteAssessment(false, assessment)}
            className="btn btn-action">
            {t('common.labels.complete')}
          </button>
        </div>
      )}
    </div>
  );
};

AssessmentCard.propTypes = {
  assessment: PropTypes.shape({
    status_fl: PropTypes.string,
    label: PropTypes.string,
    test_launch_id: PropTypes.number,
    display_order_id: PropTypes.number,
  }).isRequired,
  onCompleteAssessment: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};
